import { RouteConfig } from './RouteConfig'

export type RouteConfig = RouteConfig
export * from './AbstractRouteConfig'
export * from './SimpleRouteConfig'
export * from './withSuspense'
